module.exports = __webpack_public_path__ + "static/media/numero_principal.6619f283.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/CallWindow/numero_principal.svg
// module id = 1763
// module chunks = 0